var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("亏损赠送档位设置")]),
      _c(
        "div",
        { staticClass: "red-tiers-actions" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _setup.addTier },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "status-tip", staticStyle: { "margin-bottom": "8px" } },
        [_vm._v("保存时将按亏损门槛从低到高排序")]
      ),
      _c(
        "el-table",
        {
          staticClass: "tier-table",
          attrs: {
            data: _vm.localForm.betRebateTiers,
            border: "",
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "56", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.$index + 1))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "亏损金额", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "6px",
                        },
                      },
                      [
                        _c("span", { staticClass: "tier-gte-prefix" }, [
                          _vm._v("≥"),
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            controls: false,
                            size: "mini",
                          },
                          model: {
                            value: scope.row.threshold_yuan,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "threshold_yuan", $$v)
                            },
                            expression: "scope.row.threshold_yuan",
                          },
                        }),
                        _c("span", { staticClass: "rule-suffix" }, [
                          _vm._v("元"),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励金额", "min-width": "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "120px" },
                      attrs: {
                        min: 0,
                        precision: 2,
                        controls: false,
                        size: "mini",
                        placeholder: "请输入奖励金额",
                      },
                      model: {
                        value: scope.row.gold_yuan,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "gold_yuan", $$v)
                        },
                        expression: "scope.row.gold_yuan",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "已发放", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.settled_count))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "72", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "danger-button",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _setup.removeTier(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "16px" },
          attrs: { "label-width": "140px", label: "奖励稽核倍数" },
        },
        [
          _c("el-input-number", {
            staticClass: "rule-input-num",
            attrs: { min: 0, precision: 2, controls: false },
            model: {
              value: _vm.localForm.betRebateRule.multiple,
              callback: function ($$v) {
                _vm.$set(_vm.localForm.betRebateRule, "multiple", $$v)
              },
              expression: "localForm.betRebateRule.multiple",
            },
          }),
          _c("span", { staticClass: "rule-suffix" }, [_vm._v("倍")]),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "form-item-vips",
          attrs: { label: "活动对象", prop: "vips", "label-width": "140px" },
        },
        [
          _c(
            "div",
            { staticClass: "vips-wrap", staticStyle: { width: "80%" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: {
                    indeterminate: _setup.vipIndeterminate,
                    value: _setup.isAllVipChecked,
                  },
                  on: { change: _setup.onVipCheckAllChange },
                },
                [_vm._v(" 全选 ")]
              ),
              _c(
                "el-checkbox-group",
                {
                  staticClass: "vips-group",
                  on: { change: _setup.syncVipCheckAllState },
                  model: {
                    value: _vm.localForm.vips,
                    callback: function ($$v) {
                      _vm.$set(_vm.localForm, "vips", $$v)
                    },
                    expression: "localForm.vips",
                  },
                },
                _vm._l(_vm.vipOptions, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }